import { render, staticRenderFns } from "./BracketItemRecreate.vue?vue&type=template&id=15cae721"
import script from "./BracketItemRecreate.vue?vue&type=script&lang=js"
export * from "./BracketItemRecreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports